
import React, { useState } from 'react';
import PageLayout from '../../components/PageLayout';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import Icon from '../../components/AppIcon';

const CreateEvent = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        organization: '',
        date: '',
        location: '',
        description: '',
        maxVolunteers: 10
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Map form data to backend schema
        const payload = {
            title: formData.title,
            organization: formData.organization,
            location: formData.location,
            description: formData.description,
            schedule: new Date(formData.date).toLocaleString(), // Simple formatting
            spotsLeft: parseInt(formData.maxVolunteers),
            // Default valid values for required fields not in simple form
            impactLevel: 'High',
            cause: 'Community',
            skills: ['General Support']
        };

        try {
            const response = await fetch(`${API_BASE_URL}/opportunities`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Failed to create event');
            }

            alert("Event Created Successfully!");
            navigate('/admin-portal');
        } catch (error) {
            console.error('Error creating event:', error);
            alert("Error creating event. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageLayout variant="dark">
            <div className="max-w-2xl mx-auto bg-slate-800 p-8 rounded-xl shadow-lg border border-slate-700">
                <div className="flex items-center gap-4 mb-6">
                    <button onClick={() => navigate('/admin-portal')} className="text-slate-400 hover:text-white transition">
                        <Icon name="ArrowLeft" size={24} />
                    </button>
                    <h1 className="text-2xl font-bold text-white">Create New Event</h1>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Event Title</label>
                        <input
                            type="text"
                            name="title"
                            required
                            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="e.g. Community Park Cleanup"
                            value={formData.title}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Organization</label>
                        <input
                            type="text"
                            name="organization"
                            required
                            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="e.g. Green Earth Initiative"
                            value={formData.organization}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-2">Date & Time</label>
                            <input
                                type="datetime-local"
                                name="date"
                                required
                                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={formData.date}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-2">Location</label>
                            <input
                                type="text"
                                name="location"
                                required
                                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="e.g. Central Park"
                                value={formData.location}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Max Volunteers</label>
                        <input
                            type="number"
                            name="maxVolunteers"
                            min="1"
                            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.maxVolunteers}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Description</label>
                        <textarea
                            name="description"
                            rows="4"
                            required
                            className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Describe the event..."
                            value={formData.description}
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    <div className="flex gap-4 pt-4">
                        <Button type="button" variant="outline" onClick={() => navigate('/admin-portal')} className="flex-1 bg-transparent border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white">
                            Cancel
                        </Button>
                        <Button type="submit" variant="default" disabled={isLoading} className="flex-1 bg-blue-600 hover:bg-blue-700 text-white">
                            {isLoading ? 'Creating...' : 'Create Event'}
                        </Button>
                    </div>
                </form>
            </div>
        </PageLayout>
    );
};

export default CreateEvent;
